import { Component } from '@angular/core';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
import { WhoIsItForComponent } from '../who-is-it-for/who-is-it-for.component';
import { WhyAtomoComponent } from '../why-atomo/why-atomo.component';

@Component({
  selector: 'app-join-the-waitlist',
  standalone: true,
  imports: [WhoIsItForComponent,WhyAtomoComponent],
  templateUrl: './join-the-waitlist.component.html',
  styleUrl: './join-the-waitlist.component.scss',
  animations: [fadeInLeftOnEnterAnimation()],
})
export class JoinTheWaitlistComponent {

}
